module.exports = __webpack_public_path__ + "static/media/icon_other.c11677f6.svg";